<h2 mat-dialog-title mat-dialog-draggable-title>
     {{mode === 'ADD' ? ('config_enterprise.add_ip'| translate) : ('config_enterprise.update_ip' | translate)}}
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" style="margin-top: 16px;">
    <mat-dialog-content>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                    <input
                        matInput formControlName="ip"
                        [placeholder]="'config_enterprise.ip_address' | translate" type="text"
                        required
                        maxlength="15"
                        />
                    <button *ngIf="ipControl?.value && ipControl?.value.length > 0" mat-button type="button" matSuffix mat-icon-button
                        aria-label="Clear"
                        (click)="clearData('ip')"
                        >
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="ipControl?.invalid">{{ getIpErrorMessage() }}</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <mat-form-field class="mat-full-width">
                    <input autocomplete="off"
                        matInput [placeholder]="'config_enterprise.note' | translate"
                        type="text"
                        formControlName="description"
                        maxlength="500"
                    />
                    <button mat-button type="button" matSuffix mat-icon-button
                        aria-label="Clear"
                        *ngIf="desControl?.value && desControl?.value.length > 0"
                        (click)="clearData('description')"
                        >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button type="submit" color="primary" cdkFocusInitial [disabled]="checkDisableSave()"
        >
            <mat-icon class="mr-0">save</mat-icon>
            {{mode === 'ADD' ? ('button.add' | translate) : ('button.update' | translate)}}
        </button>
    </mat-dialog-actions>
</form>
